import { render } from "./SalePricesTable.vue?vue&type=template&id=4442fb4d&scoped=true&ts=true"
import script from "./SalePricesTable.vue?vue&type=script&lang=ts"
export * from "./SalePricesTable.vue?vue&type=script&lang=ts"

import "./SalePricesTable.vue?vue&type=style&index=0&id=4442fb4d&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4442fb4d"]])

export default __exports__